import React from 'react';
import { classNames } from '../../utils/classNames';

export const Input = ({ label, className, ...props }) => (
  <label className="block space-y-2">
    {label ? <span className="text-sm font-medium text-muted">{label}</span> : null}
    <input
      className={classNames(
        'w-full rounded-2xl border border-border bg-white/80 px-4 py-3 text-base text-text outline-none ring-0 placeholder:text-muted/80 focus:border-accent md:text-sm dark:bg-panel-strong',
        className
      )}
      {...props}
    />
  </label>
);
